import { useHttp, useTranslate, formatLocalWallClockVerDateNow } from '@/shared/lib'
import { computed, type Ref } from 'vue'
import { useMutation, useQuery } from '@tanstack/vue-query'
import { useNotification } from '@/shared/ui'

/**
 * Функция получения данных с сервера
 * @param data
 */
export const useLoadInventMapInfo = (data: Ref<number[]>) => {
  const http = useHttp()

  const queryKey = computed(() => ['load_invent_map_info', data.value.join()])

  return useQuery({
    queryKey,
    queryFn: () => {
      const searchParams = new URLSearchParams({
        object_ids: data.value.join(),
        client_now: formatLocalWallClockVerDateNow(),
      })
      return http.get(`/inventory/objects/passport?${searchParams}`)
    },
    retry: false,
    enabled: () => data.value.length > 0,
  })
}

function passportSaveErrorMessage(error: unknown): string {
  const err = error as { response?: { data?: { error?: string; data?: { msg?: string } } } }
  return err?.response?.data?.error || err?.response?.data?.data?.msg || 'request.unknown_error'
}

/**
 * Функция сохранения данных инвентаризационного объекта
 */
export const useSendInventPassport = () => {
  const http = useHttp()

  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      return http.put(`/inventory/objects/passport/${data.id}`, data)
    },
  })

  const send = async (data: any, verDate?: string): Promise<boolean> => {
    try {
      const payload = { ...data }
      if (verDate) payload.ver_date = verDate
      await mutation.mutateAsync(payload)

      addSuccess(trs('itf.saved'))
      return true
    } catch (error: unknown) {
      addError(trs(passportSaveErrorMessage(error)))
      return false
    }
  }

  return {
    ...mutation,

    send,
  }
}
